<div class="tenant-payment-form-sended" *ngIf="verificando">
    <h1 class="tenant-payment-form-sended-title">
        Verificando tu pago...
    </h1>
    <span class="tenant-payment-form-sended-description">
        Estamos confirmando el estado de tu pago con Mercado Pago. Esto puede tardar unos segundos.
    </span>
</div>
<div class="tenant-payment-form-sended" *ngIf="!verificando && operacionConcretada">
    <h1 class="tenant-payment-form-sended-title">
        ¡Muchas gracias!
    </h1>
    <span class="tenant-payment-form-sended-description">
        Estaremos en contacto con usted a la brevedad para continuar con su garantía.
    </span>
    <img src="/assets/images/scoring-result/approved/approved.png" alt="" class="approved-image">
</div>
<div class="tenant-payment-form-sended" *ngIf="!verificando && !operacionConcretada">
    <h1 class="tenant-payment-form-sended-title">
        No pudimos concretar el pago
    </h1>
    <span class="tenant-payment-form-sended-description">
        El pago fue rechazado, el link venció o quedó pendiente sin completarse. Puede intentar nuevamente con el mismo medio de pago o con otro.
    </span>
    <img src="/assets/images/scoring-result/rejected/rejected.png" alt="" class="approved-image">
    <button mat-raised-button color="primary" class="garantor-button retry-button" (click)="reintentar()" *ngIf="warrantyHash">
        Reintentar
    </button>
</div>
